module.exports = __webpack_public_path__ + "img/RAInvert-BG.8d7c88c1.png";